<template>

  <div>
    <customer-stepper-order v-if="orderSystemIsReady && branchSelectedIsReady" ref="stepper">
      <template v-slot:step1>
        <customer-order-mode @next="nextStep"></customer-order-mode>
      </template>

      <template v-slot:step2>
        <customer-product-gallery @next="nextStep"></customer-product-gallery>
      </template>

      <template v-slot:step3>
        <customer-contact-form @next="nextStep" nextButton email-required></customer-contact-form>
      </template>

      <template v-slot:step4>
        <payment-method @confirm="nextStep" submitButton></payment-method>
      </template>

      <template v-slot:step5>
        <order-review
            @next="nextStep"
            @orderCreated="onOrderCreated"
            @editLocation="goToStep(1)"
            @editProducts="goToStep(2)"
            @editContact="goToStep(3)"
            @editPayment="goToStep(4)"
        ></order-review>
      </template>


    </customer-stepper-order>

    <loading v-else/>

    <customer-order-confirmed-modal
        v-model="showConfirmedModal"
        @confirmed="$emit('orderCreatedAndConfirmed')"
    ></customer-order-confirmed-modal>
  </div>

</template>

<script>
import {Loading} from "@dracul/common-frontend"
import CustomerOrderMode from "@/modules/delivery/components-core/customer/CustomerOrderMode/CustomerOrderMode.vue";
import CustomerStepperOrder
  from "@/modules/delivery/components-core/customer/CustomerStepperOrder/CustomerStepperOrder.vue";
import CustomerProductGallery
  from "@/modules/delivery/components-core/customer/CustomerProductGallery/CustomerProductGallery.vue";
import CustomerContactForm
  from "@/modules/delivery/components-core/customer/CustomerContactForm/CustomerContactForm.vue";
import PaymentMethod from "@/modules/payment/components/PaymentMethod/PaymentMethod.vue";
import OrderReview
  from "@/modules/delivery/components-core/shared/OrderReview/OrderReview.vue";
import CustomerOrderConfirmedModal
  from "@/modules/delivery/components-core/customer/CustomerOrderConfirmedModal/CustomerOrderConfirmedModal.vue";

export default {
  name: "CustomerOrder",
  components: {
    CustomerOrderConfirmedModal,
    OrderReview,
    PaymentMethod,
    CustomerContactForm, CustomerProductGallery, CustomerStepperOrder, CustomerOrderMode, Loading
  },
  created() {
  },
  data() {
    return {
      showConfirmedModal: false
    }
  },
  methods: {

    nextStep() {
      this.$refs.stepper.nextStep();
    },
    goToStep(step) {
      this.$refs.stepper.goToStep(step);
    },
    onOrderCreated() {
      this.showConfirmedModal = true
    }
  },
  computed: {
    orderSystemIsReady() {
      return this.$store.getters.orderSystem.isSystemReady
    },
    branchSelectedIsReady(){
      return !!this.$store.getters.branchSelected
    }
  }
}
</script>

<style scoped>

</style>
